const answer1 = `
  <div>
    <p>Jobs, Jobs & Jobs - The U.S Bureau of Labor Statistics predicts that employment growth in the software engineering industry will top 24 percent between 2016 and 2026. The jobs are going unfilled. It is a good sign that there is an increasing demand for software engineers that can solve problems and build applications which are experiential, on cloud and smart.</p>
    <br/>
    <p>That’s what we’re here to teach.</p>
  </div>
`

const answer2 = `
  <div>
    <p>At the end of our Software Engineering Immersive course, you will be able to:</p>
    <ul>
      <li>Create responsive webpages for modern browsers using HTML, CSS, and JavaScript</li>
      <li>Write secure full-stack applications and deploy them to cloud based services like Heroku.</li>
      <li>Demonstrate programming and computer science fundamentals, as well as software engineering best practices.</li>
      <li>Consume web application programming interfaces (APIs) from third-party sites such as Twitter, Google, or Yelp</li>
      <li>Build a RESTful API using a technology like Sinatra, Rails, Django, or Express.</li>
      <li>Build a richly interactive, front-end single-page application using a modern framework like Angular or library like React.</li>
      <li>Collaborate as a team using Git and GitHub, widely accepted collaboration practices, and an Agile development workflow.</li>
      <li>Implement common data structures encountered in technical interview situations, such as linked lists and trees.</li>
      <li>Solve algorithm challenges and analyze the computational complexity of algorithms using Big O notation.</li>
    </ul>
  </div>
`
const faqs = {
  q1: {
    question: "Why Take This Course?",
    answer: answer1
  },
  q2: {
    question: "What Skills Will I Leave With?",
    answer: answer2,
    
  },
  q3: {
    question: "Who’s in My Class?",
    answer: `Most people in the class are not engineers and are from liberal arts education background. You will meet most of the individuals as interested in a new career path as you are. So, there is a lot of community feeling and everyone trying to help each other.`
  },
};

export default faqs;